/**
 * Resolves the "completed" date for an order from its payment history: the latest
 * payment that isn't reversed and isn't fully offset by credits, falling back to a
 * caller-supplied timestamp (e.g. the order's records.completed) when none qualify.
 *
 * @param {Array<{amount?: number, creditsApplied?: number, paymentDate?: {seconds: number}}>} payments
 * @param {{seconds: number}|Date|null|undefined} fallbackTimestamp
 * @returns {Date|null}
 */
export function resolveLastEligiblePaymentDate(payments, fallbackTimestamp) {
  const eligiblePayments = payments.filter((payment) => {
    if (payment.paymentDate?.seconds == null) return false;
    const amount = Number(payment.amount ?? 0);
    const creditsApplied = Number(payment.creditsApplied ?? 0);
    return parseFloat(amount.toFixed(2)) !== parseFloat(creditsApplied.toFixed(2));
  });

  if (eligiblePayments.length > 0) {
    const latestPayment = eligiblePayments.sort(
      (a, b) => b.paymentDate.seconds - a.paymentDate.seconds,
    )[0];
    return new Date(latestPayment.paymentDate.seconds * 1000);
  }

  if (fallbackTimestamp?.seconds != null) {
    return new Date(fallbackTimestamp.seconds * 1000);
  }

  return fallbackTimestamp ?? null;
}
